import React, { useCallback, useState } from "react";
import { BreadcrumbAdmin } from "../../../../UI/BreadcrumbAdmin";
import "../../../../Admin/Reports/Reports Detailed/ReportsDetailed.css";
import { Search } from "../../../../UI/Search/Search";
import { Button } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { UserSummaryTable } from "./UserSummaryTable";
import { Checkbox } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { debounce } from "../../../../../utils";
import { CSVLink } from "react-csv";
import DateRangePickerComp from "../../../../UI/DateRangePicker";
import { useOutsideClick } from "../../../../../hooks/useOutsideClick";

const list = [
  {
    name: "depName",
    label: "Company Name",
  },
  { name: "hod", label: "Company Admin" },
  { name: "empName", label: "Emp Name" },
  { name: "email", label: "Emp Email" },
  { name: "empId", label: "Emp ID" },
  { name: "lLogin", label: "Last Login" },
  { name: "booksComp", label: "Books Completed" },
  { name: "bookInProg", label: "Book In Progress" },
  { name: "totalPointsEarned", label: "Total Points Earned" },
];

const padDateUnit = (value) => String(value).padStart(2, "0");

const toIsoDatePart = (date) => {
  const selectedDate = new Date(date);
  const year = selectedDate.getFullYear();
  const month = padDateUnit(selectedDate.getMonth() + 1);
  const day = padDateUnit(selectedDate.getDate());
  return `${year}-${month}-${day}`;
};

const toUtcDayStartISOString = (date) => `${toIsoDatePart(date)}T00:00:00.000Z`;

const toUtcDayEndISOString = (date) => `${toIsoDatePart(date)}T23:59:59.999Z`;

export const UserSummary = () => {
  const [select, setSelect] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [dateRange, setDateRange] = React.useState(null);
  const ref = React.useRef(null);

  const closePopup = () => {
  setSelect(false);
  };

  useOutsideClick(ref, closePopup);

  const [check, setCheck] = useState({
    depName: true,
    hod: true,
    empName: true,
    email: true,
    empId: true,
    lLogin: true,
    booksComp: true,
    bookInProg: true,
    totalPointsEarned: true,
  });

  const base = [
    {
      _id: 1,
      link: "/super-admin/reports",
      label: "Reports",
    },
  ];

  const setDebouncedSearchQuery = useCallback(
    debounce((value) => {
      setSearchQuery(value);
    }, 500),
    []
  );

  const handleChange = (e) => {
    setCheck({ ...check, [e.target.name]: e.target.checked });
  };

  return (
    <div className="container">
      <BreadcrumbAdmin
        base={base}
        page={'Company User Summary'}
      />
      <div className="reportsDetailed__head">
        <Search
          mini
          setSearchVal={(val) => setDebouncedSearchQuery(val)}
          placehold={'Search by name, email, company...'}
        />
        <div className="reportsDetailed__headright">
          <DateRangePickerComp
            onChange={(value) => {
              if (!value) {
                setDateRange(null);
              } else {
                const [start, end] = value;
                if (!start || !end) {
                  setDateRange(null);
                  return;
                }
                setDateRange([
                  toUtcDayStartISOString(start),
                  toUtcDayEndISOString(end),
                ]);
              }
            }}
          />
          <div ref={ref} className="reports__selectLayout">
            <Button
              variant="outlined"
              endIcon={
                <ArrowForwardIosIcon
                  sx={{
                    transform: select ? 'rotate(-90deg)' : 'rotate(90deg)',
                    color: 'grey',
                    fontSize: '16px !important',
                  }}
                />
              }
              sx={{
                color: 'var(--grey400)',
                borderColor: 'var(--grey300)',
                width: '150px',
                fontWeight: '400 !important',
              }}
              onClick={() => setSelect(!select)}>
              Manage Field
            </Button>
            <div
              className={select ? 'reports__selectActive' : 'reports__select'}>
              <div className="reports__selectcontent">
                {list.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        defaultChecked={item.name}
                        name={item.name}
                        onChange={handleChange}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: '20px' } }}
                      />
                    }
                    onChange={handleChange}
                    label={
                      <span style={{ fontSize: '15px' }}>{item.label}</span>
                    }
                  />
                ))}
              </div>
            </div>
          </div>
          <CSVLink
            filename="User summary"
            data={csvData}>
            <Button
              variant="contained"
              endIcon={<FileUploadOutlinedIcon sx={{ color: 'white' }} />}>
              Export
            </Button>
          </CSVLink>
        </div>
      </div>

      <div className="reports__table">
        <UserSummaryTable
          check={check}
          searchQuery={searchQuery}
          startDate={dateRange && dateRange[0]}
          endDate={dateRange && dateRange[1]}
          getTableData={(data) => {
            let cleanedCSVData = data?.data?.map((obj) => {
              let d = {
                'User name': `${obj.fname} ${obj.lname}`,
                'User email': obj.email,
                'Employee id': obj.employeeId,
                'User company': obj.company?.name,
                'Last login': obj.lastLogin,
                'Total points earned': obj.totalPointsEarned,
                'Books in progress': obj.booksInProgress,
                'Books completed': obj.booksCompleted,
              };
              return d;
            });
            setCsvData(cleanedCSVData);
          }}
        />
      </div>
    </div>
  );
};
